import React from 'react';
import { NotificationPanel } from '@repo/ui';
import twinlabsAiStackedLogo from '@repo/assets/logos/twinlabs-ai-stacked-logo.svg';

const PermissionDeniedPage: React.FC = () => {
  return (
    <>
      <NotificationPanel
        imgSrc={twinlabsAiStackedLogo}
        imgAlt="Twinlabs.ai Logo"
        header="Permission Denied Page"
        copy="Please contact your administrator."
        backRoute="/account/dashboard"
      />
    </>
  );
};

export default PermissionDeniedPage;
